import api from "core/api/api";

function getCDCParams(model) {
    return {
        useConnectionProfile: model.get("useConnectionProfile"),
        connectionProfileName: model.get("connectionProfileName"),
        OAuthAuthorizationFlows: model.get("authMethod"),
        autoAuthTokenRenewal: model.get("authMethod") !== "authToken",
        Username: model.get("username"),
        Password: model.get("password"),
        securityToken: model.get("securityToken"),
        consumerKey: model.get("consumerKey"),
        consumerSecret: model.get("consumerSecret"),
        accesstoken: model.get("authToken"),
        apiEndPoint: model.get("host"),

        JWTKeystorePath: model.get("JWTKeystorePath"),
        JWTKeystorePassword: model.get("JWTKeystorePassword"),
        JWTCertificateName: model.get("JWTCertificateName")
    };
}

function getILParams(model) {
    return {
        Username: model.get("username"),
        Password: model.get("password"),
        OAuthAuthorizationFlows: model.get("authMethod"),
        securityToken: model.get("securityToken"),
        autoAuthTokenRenewal: model.get("authMethod") !== "authToken",
        consumerKey: model.get("consumerKey"),
        consumerSecret: model.get("consumerSecret"),
        authToken: model.get("authToken"),
        apiEndPoint: model.get("host"),
        connectionProfileName: model.get("connectionProfileName"),
        JWTKeystorePath: model.get("JWTKeystorePath"),
        JWTKeystorePassword: model.get("JWTKeystorePassword"),
        JWTCertificateName: model.get("JWTCertificateName")
    };
}

export default {
    wizardType: "SALESFORCE",

    getConnectionParams: (type, model) => getILParams(model),

    async validateConnection(model, agentName, { isCDC }) {
        const wizardType = isCDC ? "SALESFORCECDC" : "SALESFORCE";
        const params = isCDC ? getCDCParams(model) : getILParams(model);

        const data = await api.WizardHelper_ValidateConnection(wizardType, params, agentName).catch(e => {
            console.error(e);
            throw "Problem Validating Connection. Please check the logs for detailed information.";
        });
        if (data.result === true) {
            model.set("authToken", data.message);
            return data;
        }
        throw data;
    },

    async fetchTableWrapper(model, agentName, metaObjectFQN, adapterName_version, { isCDC }) {
        if (isCDC) {
            return api.WizardHelper_GetChannels(
                "SALESFORCECDC",
                getCDCParams(model),
                agentName,
                metaObjectFQN,
                adapterName_version
            );
        }
        return api.WizardHelper_GetObjectsWithExtraParam(
            "SALESFORCE",
            {
                authToken: model.get("authToken"),
                apiEndPoint: model.get("host"),
                connectionProfileName: model.get("connectionProfileName")
            },
            model.get("customObjects") ? "true" : "false",
            agentName,
            metaObjectFQN,
            adapterName_version
        );
    }
};
